import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1581.176,451.765 L112.942,451.765 L112.942,282.353 C112.942,250.729 137.788,225.882 169.412,225.882 L338.823,225.882 L338.823,282.353 C338.823,313.976 363.671,338.824 395.294,338.824 C426.918,338.824 451.765,313.976 451.765,282.353 L451.765,225.882 L1242.354,225.882 L1242.354,282.353 C1242.354,313.976 1267.2,338.824 1298.824,338.824 C1330.447,338.824 1355.294,313.976 1355.294,282.353 L1355.294,225.882 L1524.706,225.882 C1556.329,225.882 1581.176,250.729 1581.176,282.353 L1581.176,451.765 Z M734.118,1491.953 L355.765,1112.471 L434.823,1033.412 L734.118,1331.576 L1259.294,807.529 L1338.354,886.588 L734.118,1491.953 Z M1524.706,112.941 L1355.294,112.941 L1355.294,56.471 C1355.294,24.847 1330.447,0 1298.824,0 C1267.2,0 1242.354,24.847 1242.354,56.471 L1242.354,112.941 L451.765,112.941 L451.765,56.471 C451.765,24.847 426.918,0 395.294,0 C363.671,0 338.823,24.847 338.823,56.471 L338.823,112.941 L169.412,112.941 C75.671,112.941 -4.54747351e-13,188.612 -4.54747351e-13,282.353 L-4.54747351e-13,1920 L1694.118,1920 L1694.118,282.353 C1694.118,188.612 1618.447,112.941 1524.706,112.941 L1524.706,112.941 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1",
  transform: "translate(113)"
});

var IconCalendarReservedSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCalendarReservedSolid, _Component);

  var _super = _createSuper(IconCalendarReservedSolid);

  function IconCalendarReservedSolid() {
    _classCallCheck(this, IconCalendarReservedSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCalendarReservedSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCalendarReserved",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCalendarReservedSolid.displayName = "IconCalendarReservedSolid";
  return IconCalendarReservedSolid;
}(Component);

IconCalendarReservedSolid.glyphName = 'calendar-reserved';
IconCalendarReservedSolid.variant = 'Solid';
IconCalendarReservedSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCalendarReservedSolid;
export { IconCalendarReservedSolid };